var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registration-tag-badge"},[(_vm.equipment.attested)?_c('b-badge',[_vm._v(" "+_vm._s((_vm.equipment.registration || {}).tagDisplay)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }